import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useMemo, useState} from "react";
import {ISort, IStaticFilter} from "../../../models/base/base-query";
import {tableOnChange} from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import Space from "../../general/antd/space";
import {Button, Tag} from "antd";
import ViewBtn from "../../general/table-components/actions/view-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, {EVENT_SUCCESS} from "../../../utils/events";
import {ColumnsType} from "antd/es/table";
import {ICampaign} from "../../../models/campaign/response";
import {CampaignStatus, getCampaignStatusName, getColor, getPeriodicTypeName} from "../../../models/campaign/enums";
import CampaignContext from "../../../context/campaign/context";
import {getPeriodRatio} from "../../../models/donation/enum";

interface IProps {
   
}

const CampaignTable: React.FC<IProps> = (props) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const { list, actions, loading, query } = useContext(CampaignContext);


    const columns: ColumnsType<ICampaign> = [
        {
            title: t("id"),
            dataIndex: "id",
            key: "id",
            width: 80,
        },
        {
            title: t("name"),
            dataIndex: "name",
            key: "name",
        },
        {
            title: t("charity"),
            dataIndex: ["charity", "name"],
            key: "charity",
        },
        {
            title: t("target_amount"),
            dataIndex: "targetAmount",
            key: "targetAmount",
        },
        {
            title: t("paid_amount"),
            dataIndex: "paidAmount",
            key: "paidAmount",
        },
        {
            title: t("donation_type"),
            dataIndex: "period",
            render: (_, record) => (record?.periodic? t('periodic') :t('non_periodic'))
        },
        {
            title: t("period_ratio"),
            dataIndex: "periodRatio",
            render: (_, record) => (record?.periodicType && record.periodicType.length > 0 ?
                record.periodicType.map((type: number) => (
                    <Tag color={getColor(type)} key={type}>{getPeriodicTypeName(type)}</Tag>
                ))
                : "--")
        },
        {
            title: t("number_of_beneficiaries"),
            dataIndex: "numberOfBeneficiaries",
            key: "numberOfBeneficiaries",
        },
        {
            title: t("status"),
            dataIndex: "status",
            key: "status",
            render: (status) => {
                let color = 'default';

                switch (Number(status)) {
                    case CampaignStatus.NOT_STARTED:
                        color = 'default';
                        break;
                    case CampaignStatus.COLLECTING_DONATIONS:
                        color = 'processing';
                        break;
                    case CampaignStatus.FINISHED:
                        color = 'warning';
                        break;
                    case CampaignStatus.COMPLETED:
                        color = 'success';
                        break;
                }

                return <Tag color={color}>{t(getCampaignStatusName(Number(status)))}</Tag>;
            }
        },
        {
            title: t("actions"),
            dataIndex: "",
            width: 250,
            fixed: "right",
            align: "center",
            key: "x",
            render: (_: any, record) => (
                <Space>
                    <ViewBtn
                        onClick={async () => {
                            navigate(`details/${record?.id}`);
                        }}
                    />
                    <EditBtn
                        onClick={async () => {
                            navigate(`update/${record?.id}`);
                        }}
                    />
                    <DeleteBtn
                        onConfirm={async () => {
                            await actions.deleteCampaign(record?.id);
                            eventManager.emit(EVENT_SUCCESS);
                        }}
                        loading={loading.includes("delete")}
                    />
                </Space>
            ),
        }
    ];

    let tableFiltersProps = {};
    const [sorts, setSorts] = useState<ISort[]>([]);
    const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

    useEffect(() => {
        sorts.length > 0 &&
        actions.setQuery({
            ...query,
            orders: sorts,
        });
    }, [sorts]);

    return (
        <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        dataSource={list?.data ?? []}
        loading={loading.includes("list")}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
        />
    )
}
export default CampaignTable;